export const HEALTH_CHECK_TIMEOUT = 10000 // in ms

export const MAX_ALLOWED_FRAUD_DELTA = 30 * 1000 // in ms

export const FRAUD_PROTECTION = "FraudProtection"

export const MUTATION_IN_PAST = "MutationInPast"

export const MUTATION_IN_FUTURE = "MutationInFuture"
